import clsx from 'clsx';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { Box, Container, Typography, Grid, Button, Link } from '@mui/material';
import { useStyles } from './styles';
import useIsMobile from 'hooks/useIsMobile';

export default function AboutSection() {
  const classes = useStyles();
  const router = useRouter();
  const isMobile = useIsMobile();

  return (
    <>
      <Box py={6} bgcolor="grey.200">
        <Container>
          <Grid container={true} spacing={2} alignItems="center">
            <Grid item={true} xs={12} md={6}>
              <Box px={6} className={classes.bannerInfographic}>
                <img src="/images/template-icon.svg" alt="Infographic idea icon" />

                <Typography
                  className={classes.primaryColor}
                  variant="h5"
                  component="h2"
                  gutterBottom={true}
                >
                  <b>Need a more specific infographic template?</b>
                </Typography>

                <Typography className={classes.bannerInfographic}>
                  If you can't find the perfect template for communicating your research, you can
                  count on our on-demand service. All our presentation templates are made specially
                  for you by professional designers and curated by our science team.
                </Typography>

                {!isMobile && (
                  <NextLink href="/custom-services" passHref={true}>
                    <Button
                      className={clsx(classes.button, classes.primaryButton)}
                      color="primary"
                      variant="contained"
                    >
                      Learn more
                    </Button>
                  </NextLink>
                )}
              </Box>
            </Grid>

            <Grid item={true} xs={12} md={6}>
              <NextLink href="/custom-services" passHref={true}>
                <Link underline="hover">
                  <img
                    className={classes.sectionImage}
                    src="/images/on-demand-presentation-templates.svg"
                    alt="On-demand presentation templates"
                  />
                </Link>
              </NextLink>

              {isMobile && (
                <Box className={classes.bannerInfographic}>
                  <NextLink href="/custom-services" passHref={true}>
                    <Button
                      className={clsx(classes.button, classes.primaryButton)}
                      color="primary"
                      variant="contained"
                    >
                      Learn more
                    </Button>
                  </NextLink>
                </Box>
              )}
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className={classes.labBg} py={10} textAlign="center">
        <Container>
          <Typography className={classes.whiteColor} variant="body1">
            Mind the Graph is a team of designers and scientists, with the dream of <br />
            simplifying and spreading visual scientific communication across the globe. <br />
            We care about your success with visual communication and scientific education. <br />
            Our goal is to help scientists and researchers clearly communicate their ideas and{' '}
            <br />
            findings with no effort, using accurate and impactful visuals.
          </Typography>

          <NextLink
            href={`/auth/login-register?from_url=${router.basePath + router.asPath}`}
            passHref={true}
          >
            <Button
              className={clsx(classes.button, classes.whiteButton)}
              color="primary"
              variant="contained"
            >
              Get started
            </Button>
          </NextLink>
        </Container>
      </Box>
    </>
  );
}
